import { useNavigate } from 'react-router-dom';
import { LogOut, User, Home } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const Header = ({ showHome = true }) => {
  const navigate = useNavigate();
  const username = localStorage.getItem('username') || 'User';
  const role = localStorage.getItem('role') || 'user';

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('role');
    toast.success('Logged out successfully');
    navigate('/login');
  };

  return (
    <div className="bg-white shadow-sm border-b sticky top-0 z-40">
      <div className="max-w-7xl mx-auto px-4 py-3 flex justify-between items-center">
        <div className="flex items-center gap-4">
          {showHome && (
            <Button variant="ghost" size="sm" onClick={() => navigate('/')}>
              <Home size={18} className="mr-1" />
              Dashboard
            </Button>
          )}
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center text-gray-600">
            <User size={18} className="mr-2" />
            <span className="font-medium">{username}</span>
            {role === 'admin' && (
              <span className="ml-2 text-xs bg-purple-100 text-purple-700 px-2 py-0.5 rounded">Admin</span>
            )}
          </div>
          <Button variant="outline" size="sm" onClick={handleLogout}>
            <LogOut size={16} className="mr-1" />
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Header;
